
export const name = "ecosystem-marketplace-apps-public-ui";
export const version = "dev";
